export default __webpack_public_path__ + "static/media/noa-45.ee442673.jpg";